/*!
 * @preserve
 * IPv6Test.js
 * JS-Bestandteil des IPv6-Test (BrowserInfoCollector Contao Modul / dein-ip-check.de)
 *
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */
import jqXHR = JQuery.jqXHR;

export enum INetProtocol {"IPv4" = "ipv4", "IPv6" = "ipv6"}

interface IAsn { ipv4: string | null, ipv6: string | null }
let asn: IAsn = { ipv4 : null, ipv6 : null };

//let version: webglversion = { major : null, minor : null };

export class detectIP {
    /**
     * Update IPv4 or IPv6-Information
     * @param protocol
     * @param primeryProtocol
     */
    public static updateIP(protocol: INetProtocol, primeryProtocol: INetProtocol) {
        let ipvtest: jqXHR<any>;
        let sprintf = require('sprintf-js').sprintf;
        let statusText: Array<string> = [];
        
        let url = `https://${protocol}-test.dein-ip-check.de/ajax/v2/ip?lang=${DETECTLANGUAGE}`;
        if (protocol === INetProtocol.IPv6) {
            url = `https://${protocol}-test.dein-ip-check.de/ajax/v2/ip?lang=${DETECTLANGUAGE}`
        }
        
        ipvtest = $.ajax({
            url: url,
            dataType: "json", 
            timeout: 3000
        }).done(function () {
            if (ipvtest.responseJSON.status === "OK") {
                // ASN speichern
                (protocol === INetProtocol.IPv4) ? 
                    asn.ipv4 = ipvtest.responseJSON.asnnumber : asn.ipv6 = ipvtest.responseJSON.asnnumber;
                
                // Daten ausgeben
                $(`#${protocol}adress`)
                    .val(ipvtest.responseJSON.ip)
                    .prop("disabled", false);
                $(`#${protocol}hostname`).html(ipvtest.responseJSON.hostname);
                $(`#${protocol}isp`).text(`${ipvtest.responseJSON.provider} (AS ${ipvtest.responseJSON.asnnumber})`);
                $(`#${protocol}Clipboard`)
                    .prop( "disabled", false );
                $(`#${protocol}whois`)
                    .prop( "disabled", false );
                
                // Prüfe ob eine IPv6 Verbindung mit Tunnel vorliegt
                if (protocol === INetProtocol.IPv6 && 
                    (ipvtest.responseJSON["tunnel"] === true
                    || ipvtest.responseJSON["teredo"] === true
                    || ipvtest.responseJSON["6to4"] === true)
                ) {
                    // DEFINTIV liegt ein Tunnel vor
                    let tunnelType:string = "Tunnel";
                    if(ipvtest.responseJSON["tunnel"] === true) {
                        tunnelType = "Tunnelbroker";
                    } else if(ipvtest.responseJSON["teredo"] === true) {
                        tunnelType = "Teredo-Tunnel";
                    } else if(ipvtest.responseJSON["6to4"] === true) {
                        tunnelType = "6to4-Tunnel";
                    }
                    
                    // Status-Text bei Nutzern die ein Tunnel verwenden
                    statusText.push(
                        sprintf(DETECTPHRASE["Sie verwenden für Ihren IPv6-Zugang einen %s."], [tunnelType]) + " " +
                        DETECTPHRASE['Dies kann zu Einschränkungen bei IPv6-Verbindungen führen.']
                    );
                    
                    // Testergebnis
                    $(`#${protocol}testLabel`)
                        .removeClass("fa-spin").removeClass("fa-sync")
                        .removeClass("bg-info").removeClass("bg-danger").removeClass("bg-success")
                        .addClass("bg-warning")
                        .addClass("fa-exclamation");
                    $(`#${protocol}test`).text(DETECTPHRASE["Eingeschränkt unterstützt"]);
                } else {
                    // Keine IPv6-Verbindung mit einem aktivierten Tunnel
                    if(protocol === INetProtocol.IPv6 && asn.ipv4 !== asn.ipv6) {
                        // der IPv6-Zugang wird geprüft, kein Tunnel liegt vor, aber die ASN ist unterschiedlich
                        $(`#${protocol}testLabel`)
                            .removeClass("fa-spin").removeClass("fa-sync")
                            .removeClass("bg-info").removeClass("bg-danger").removeClass("bg-success")
                            .addClass("bg-success")
                            .addClass("fa-lightbulb-exclamation");
                        $(`#${protocol}test`).text(DETECTPHRASE["Unterstützt"]);

                        // Status-Text falls zwei getrennte Netze verwendet wurden
                        statusText.push( 
                            DETECTPHRASE['Ihr Provider verwendet zwei getrennte Netze für IPv4 und IPv6. ' +
                            'Daher kann ein Tunnel nicht ausgeschlossen werden.']
                        );
                    } else {
                        // Zugang ist ohne Tunnel und ASN ist gleich 
                        $(`#${protocol}testLabel`)
                            .removeClass("fa-spin").removeClass("fa-sync")
                            .removeClass("bg-info").removeClass("bg-warning").removeClass("bg-danger")
                            .addClass("bg-success")
                            .addClass("fa-check");
                        $(`#${protocol}test`).text(DETECTPHRASE["Unterstützt"]);
                    }

                    // SLAAC / Autokonfiguration ohne Privacy Extension
                    if(protocol === INetProtocol.IPv6) {
                        let ip6 = require('ip6');
                        //Debug: ipvtest.responseJSON.ip = "2001:db8:1:1000:211:22ff:fe33:4455";
                        let ipv6splittet = ip6.normalize(ipvtest.responseJSON.ip).split(":");

                        // SLAAC Merkmal prüfen
                        if((ipv6splittet[5] + ipv6splittet[6]).substr(2,4).toLowerCase() === "fffe") {
                            // Privacy-Extension nicht aktiv bei SLAAC Nutzern
                            statusText.push(
                                DETECTPHRASE['Ihre IPv6-Adresse wurde über <q>Stateless address autoconfiguration</q> (SLAAC) ' +
                                'ihrem System automatisch zugeordnet. Hierbei ist aus Datenschutzgründen empfohlen ' + 
                                'die Privacy Extensions (RFC4941) zu aktivieren.']
                            );

                            $(`#${protocol}testLabel`)
                                .removeClass("fa-spin").removeClass("fa-sync")
                                .removeClass("fa-question").removeClass("fa-check")
                                .removeClass("bg-info").removeClass("bg-warning").removeClass("bg-danger")
                                .addClass("bg-success")
                                .addClass("fa-lightbulb-exclamation");
                        }
                    }
                }
            } else {
                console.warn("AJAX Request zu einem ungültigen Ergebnis");
                $(`#${protocol}adress`)
                    .val(`IPv4-${DETECTPHRASE["Ermittlung wurde nicht durchgeführt"]}`)
                    .prop("disabled", true );
                $(`#${protocol}hostname`).text(`IPv4-${DETECTPHRASE["Ermittlung wurde nicht durchgeführt"]}`);
                $(`#${protocol}isp`).text(`IPv4-${DETECTPHRASE["Ermittlung wurde nicht durchgeführt"]}`);
                $(`#${protocol}test`).text(DETECTPHRASE["Nicht ermittelbar"]);
                $(`#${protocol}testLabel`).removeClass("bg-warning")
                    .addClass("bg-warning")
                    .removeClass("fa-spin")
                    .removeClass("fa-sync")
                    .addClass("fa-question");
                $(`#${protocol}ClipboardButton`)
                    .prop( "disabled", true );
                $(`#${protocol}whois`)
                    .prop( "disabled", true );
            }
            
            // 
            // Handelte es sich um den sekundären Zugang?
            //
            if(protocol !== primeryProtocol) {
                $("#ipfallback").removeClass("label-info").addClass("label-success");
            }
            
            // 
            // Statustext ausgeben
            // 
            if(statusText.length > 0) {
                $("#statusInfo").removeClass("hidden");
                $("#statusInfo .panel-body").html(statusText.join("<br /><br />"));
            }
        }).fail(function (jqXHR, textStatus) {
            console.warn(`Test for ${protocol} failed: ${textStatus}`);
            $(`#${protocol}adress`).val(DETECTPHRASE["Nicht ermittelbar"]);
            $(`#${protocol}hostname`).text(DETECTPHRASE["Nicht ermittelbar"]);
            $(`#${protocol}isp`).text(DETECTPHRASE["Nicht ermittelbar"]);
            $(`#${protocol}test`).text(DETECTPHRASE["Nicht unterstützt"]);
            $(`#${protocol}testLabel`).removeClass("bg-info")
                .addClass("bg-danger")
                .removeClass("fa-spin")
                .removeClass("fa-sync")
                .addClass("fa-times");
            
            if(protocol !== primeryProtocol) {
                $("#ipfallback").removeClass("label-info")
                    .removeClass("label-success")
                    .addClass("label-danger")
                    .text( DETECTPHRASE["zu"] + " " + (protocol === INetProtocol.IPv6 ? "IPv6" : "IPv4") + " " + DETECTPHRASE["fehlgeschlagen"]);
            } else {
                $("#ipprefer").removeClass("label-info")
                    .removeClass("label-success")
                    .addClass("label-danger")
                    .text((protocol === INetProtocol.IPv6 ? "IPv6" : "IPv4") + " " + DETECTPHRASE["fehlgeschlagen"]);
            }
        }).always(function() {
            // Frage im Anschluss an die IPv4-Daten die IPv6-Daten ab
            if (protocol === INetProtocol.IPv4) {
                detectIP.updateIP(INetProtocol.IPv6, (isIPv6 === "1" ? INetProtocol.IPv4 : INetProtocol.IPv4));
            }
        });   
    }

    /**
     * Primäres Protokoll an den Nutzer melden
     * 
     * @param isIpV6
     */
    public static detectPrimaryProtocol(isIpV6: boolean) {
        if(isIpV6) {
            $("#ipprefer").text("IPv6")
                .removeClass("label-info").addClass("label-success");
            $("#ipfallback").text(`${DETECTPHRASE["zu"]} IPv4 (${DETECTPHRASE["<1 Sekunde"]})`);
        } else {
            $("#ipprefer").text("IPv4")
                .removeClass("label-info").addClass("label-success");
            $("#ipfallback").text(`${DETECTPHRASE["zu"]} IPv6 (${DETECTPHRASE["<1 Sekunde"]})`);
        }
    }
}
